/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { Reducer, AnyAction } from "redux";

import { GET_STUDY_ITEMS, CLEAR_STUDY_DATA } from "../actions/types";

type StudyObjects = {
  [course: string]: {
    _id: string;
    title: string;
  };
};

export type StudyState = {
  readonly studyLecs: StudyObjects | undefined;
  readonly studyHdo: StudyObjects | undefined;
  readonly studyCards: StudyObjects | undefined;
  readonly studyTests: StudyObjects | undefined;
  readonly studyAsm: StudyObjects | undefined;
};

const studyReducerDefaultState: StudyState = {
  studyLecs: undefined,
  studyHdo: undefined,
  studyCards: undefined,
  studyTests: undefined,
  studyAsm: undefined,
};

export const studyData = [
  "studyLecs",
  "studyHdo",
  "studyCards",
  "studyTests",
  "studyAsm",
];

export const studyReducer: Reducer<StudyState, AnyAction> = (
  state = studyReducerDefaultState,
  action: AnyAction,
) => {
  switch (action.type) {
    case GET_STUDY_ITEMS:
      const idx: number = action.payload.type;
      return { ...state, [studyData[idx]]: action.payload.data };

    case CLEAR_STUDY_DATA:
      return studyReducerDefaultState;

    default:
      return state;
  }
};
